import {Injectable} from '@angular/core';
import {Globals} from "@app/services/globals.service";

@Injectable({
    providedIn: 'root'
})
export class HelperService {

    appUsers = [];

    constructor(private globals: Globals) {
    }

// funkcija koja vraca string od datuma (npr) : 10.05.2021 => 10 Maj
    getDateAndMonthName(date) {
        let string = '';
        date = new Date(date);
        string = date.getDate();
        switch (new Date(date).getMonth()) {
            case 0:
                string = string + ' jan';
                break;
            case 1:
                string = string + ' feb';
                break;
            case 2:
                string = string + ' mar';
                break;
            case 3:
                string = string + ' apr';
                break;
            case 4:
                string = string + ' maj';
                break;
            case 5:
                string = string + ' jun';
                break;
            case 6:
                string = string + ' jul';
                break;
            case 7:
                string = string + ' avg';
                break;
            case 8:
                string = string + ' sept';
                break;
            case 9:
                string = string + ' okt';
                break;
            case 10:
                string = string + ' nov';
                break;
            case 11:
                string = string + ' dec';
                break;

            default:
                string = string;
        }
        return string;


    }

    getDataForUserId(id) {
        let data = {};
        const y = Object.values(this.globals.allAppUsers).find(x => x['id'] === id);

        if (y !== undefined) {
            data = y;
        }
        return data;
    }

    getUserDataForIds(userIds: []) {
        let data = [];
        userIds.forEach(id => {
            const y = Object.values(this.globals.allAppUsers).find(x => x['id'] === id);
            if (y !== undefined) {
                data.push(y);
            }
        })
        return data;

    }

    //za datepicker vraca objekat potreban za ngb datepicker
    tranformStringToDate(date) {
        let str = date.split('-');
        let y = str[0];
        let m = str[1];
        let d = str[2];

        let transformedData = {year: parseInt(y), month: parseInt(m), day: parseInt(d)};
        return transformedData;
    }


    //funkcija koja vraca datum u formi npr "Prije 10 dana" ili vraca datum ako proslo vise od 10 dana
    getStringDateFormat(date: string) {
        let string = '';
        let date1 = new Date(date);
        let today = new Date();

        let differenceInMiliseconds = today.getTime() - date1.getTime();
        let diffInDays = Math.floor((differenceInMiliseconds / (1000 * 3600 * 24)));
        string = 'Prije ' + diffInDays + ' dana';
        if (diffInDays > 14) {
            string = date;
        }
        if (diffInDays === 0) {
            string = 'Danas';
        }

        return string;


    }

    public tranformStatusToName(status) {
        let str = '';

        switch (status) {

            case 'todo':
                str = 'Otvoren';
                break;

            case 'inprogress':
                str = 'U radu';
                break;

            case 'ddone':
                str = 'Završen';
                break;

            case 'canceled':
                str = 'Otkazan';
                break;

            case 'deleted':
                str = 'Izbrisan';
                break;

            case 'postponed':
                str = 'Odložen';
                break;

            case 'validated':
                str = 'Odobren';
                break;

            default:
                str = '';
                break;


        }
        return str;
    }


}
